module.exports = __webpack_public_path__ + "img/04.479f91a3.jpg";